export const SET_LOAD_INDICATOR_VISIBILITY = 'SET_LOAD_INDICATOR_VISIBILITY'